import { RootState } from '@/store';

import { GetterTree } from 'vuex';
import { State } from './state';
import { CEadVal, CEadValPos, Entwurf, NEadSubPos } from '@/modules/zelos/models/Zelos/ZelosModels';
import { DocumentFile } from '@/modules/zelos/models/Zelos/ZelosModels';

export type Getters = {
  entwurfe(state: State): Array<Entwurf>;

  neadsubpos(state: State): Array<NEadSubPos>;
  neadsubDoc(state: State): DocumentFile | null;

  ceadval(state: State): Array<CEadVal>;
  ceadvalpos(state: State): Array<CEadValPos>;
};

export const getters: GetterTree<State, RootState> & Getters = {
  entwurfe(state: State) {
    return state.entwurfe;
  },

  neadsubpos(state: State) {
    return state.neadsubpos;
  },

  neadsubDoc(state: State) {
    return state.neadsubDoc;
  },

  ceadval(state: State) {
    return state.ceadval;
  },

  ceadvalpos(state: State) {
    return state.ceadvalpos;
  },
};
